globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.SelectMediaLogo = (function (superClass) {

  utils.extend(SelectMediaLogo, superClass);

  function SelectMediaLogo() {
    this.uploadPath = '/configuration/mediatheque/logos/upload';

    return SelectMediaLogo.__super__.constructor.apply(this, arguments);
  }

  $.extend(SelectMediaLogo.prototype, {
    init: function () {
      return SelectMediaLogo.__super__.init.apply(this, arguments);
    },
    _initSelectedMediaData: function () {
      var modal = this;
      if (modal.$selectedMediaAbstractFile.length) {
        modal.selectedMediaLogoData = {
          id: modal.$selectedMediaAbstractFile.data('id'),
          type: modal.$selectedMediaAbstractFile.data('type'),
          url: modal.$selectedMediaAbstractFile.data('url')
        }
      }
    },
    _selectMediaAbstractFile: function ($mediaLogo) {
      var modal = this,
        $selectedMediaLogo = modal.$selectedFileContainer.find('.thumbnail');

      appCustomerSpace.Loader().start({ $container: modal.$selectedFileContainer, options: { text: '' } });

      if (!$selectedMediaLogo.length) $selectedMediaLogo = modal._selectedMediaAbstractFileTemplate();

      modal.selectedMediaLogoData = {
        id: $mediaLogo.data('id'),
        type: $mediaLogo.data('type'),
        url: $mediaLogo.data('url')
      }

      modal.$mediaAbstractFilesContainer.find('.file-item').removeClass('selected');
      $mediaLogo.addClass('selected');

      if ($selectedMediaLogo.length) {
        $selectedMediaLogo.find('img').attr('src', modal.selectedMediaLogoData.url);
        modal.$selectedFileContainer.html($selectedMediaLogo);
      }
    },
    _submit: function () {
      var modal = this,
        $fieldContainer = $(`#${modal.options.data.preview_dom_id}`);

      modal.options.data.image_id = modal.selectedMediaLogoData.id;

      if ($fieldContainer.length) {
        $fieldContainer.find('img').attr('src', modal.selectedMediaLogoData.url).end()
          .find('input.file-id[type=hidden]').val(modal.selectedMediaLogoData.id).trigger('change').end()
          .find('input.file-type[type=hidden]').val(modal.selectedMediaLogoData.type).end()
          .find('.btn.delete.disabled').removeClass('disabled')
          .find('.open-modal').attr('data-modal-options', JSON.stringify(modal.options))

        modal.close();
      }
    }
  });

  return SelectMediaLogo;

})(appCustomerSpace.Modals.Settings.SelectMediaAbstractFile);
